export function setLevel(state, payload) {
  const showLevelSelector = false;
  const menuList = payload.MENU_LIST;
  const currentChapter = getCurrentChapter(payload);
  const designChapter = getDesignChapter(payload.DESIGN_CHAPTER);
  const drawerCollapsed = false;
  const notebook = payload.GENERAL_CONFIG;
  return {
    showLevelSelector,
    menuList,
    currentChapter,
    designChapter,
    drawerCollapsed,
    notebook,
    ...payload.GENERIC_CHAPTERS,
  };
}

/**
 * Function is to fetch the data for currentChapter to be displayed on the Notebook;
 * This is by default the CONTEXT chapter
 * Assumption for the function is that CONTEXT or any other chapter to be deemed as the current
 * will be initially in the payload.GENERIC_CHAPTERS section.
 */
function getCurrentChapter(payload) {
  const currentMenuValue = payload.MENU_LIST.find((menu) => menu.current).value;
  return payload.GENERIC_CHAPTERS[currentMenuValue];
}

function getDesignChapter({ currentView, allViews, ...rest }) {
  return {
    ...rest,
    ...allViews,
    currentView: allViews[currentView],
    ...extraAttributes(),
  };
}

//This function is temporarily added for adding attributes
//that are required but has not been integrated
function extraAttributes() {
  return {
    longestStreak: 0,
  };
}
